<template>
  <div class="form-property-details">
    <ElForm class="form-property-details__form form"
            ref="propertyFormRef"
            :model="propertyForm"
            @submit.native.prevent
    >
      <ElRadioGroup
        id="property-type-car"
        v-model="propertyForm.typeCar"
        v-show="!isMobile"
        size="large"
        @change="(value) => $emit('change-type', value)"
      >
        <ElRadioButton
          v-input-id="'property-type-single'"
          label="single"
        >
          Одно ТС
        </ElRadioButton>
        <ElRadioButton
          v-input-id="'property-type-multi'"
          label="multi"
        >
          Несколько ТС
        </ElRadioButton>
      </ElRadioGroup>

      <ElFormItem
        v-show="propertyForm.typeCar === 'single'"
        class="form__item"
        prop="cars.0.regNum"
        :rules="[{
            validator: validateRegNum,
            trigger: ['blur']
          }]"
      >
        <ElInput :id="`car-reg-num-${0}`"
          v-model="propertyForm.cars[0].regNum"
          placeholder="Регистрационный номер"
          @input="(value) => handleRegNum(0, value)"
        >

          <template #prefix>
            Регистрационный номер
          </template>
        </ElInput>
      </ElFormItem>

      <ElFormItem
        v-if="isShowFieldsSingle"
        class="form__item"
        prop="cars.0.brand"
        :rules="[{
            required: true,
             message: 'Обязательно для заполнения',
            trigger: ['blur']
          }]"
      >
        <ElInput :id="`car-brand-${0}`"
          v-model="propertyForm.cars[0].brand"
          placeholder="Марка"
          :disabled="propertyForm.cars[0].brandAutocode"
        >
          <template #prefix>
            Марка
          </template>
        </ElInput>
      </ElFormItem>

      <ElFormItem
        v-if="isShowFieldsSingle"
        class="form__item"
        prop="cars.0.model"
        :rules="[{
            required: true,
            message: 'Обязательно для заполнения',
            trigger: ['blur']
          }]"
      >
        <ElInput :id="`car-model-${0}`"
          v-model="propertyForm.cars[0].model"
          placeholder="Модель"
          :disabled="propertyForm.cars[0].modelAutocode"
        >
          <template #prefix>
            Модель
          </template>
        </ElInput>
      </ElFormItem>

      <div
        v-if="isShowFieldsSingle"
        class="form__item form__item--col"
      >
        <ElFormItem
          class="form__col form__col--half"
          prop="cars.0.year"
          :rules="[{
            validator: validateYear,
            trigger: ['blur']
          }]"
        >
          <ElInput :id="`car-year-${0}`"
            v-model="propertyForm.cars[0].year"
            placeholder="Год выпуска"
            v-mask="'9999'"
            :disabled="propertyForm.cars[0].yearAutocode"
          >
            <template #prefix>
              Год выпуска
            </template>
          </ElInput>
        </ElFormItem>

        <ElFormItem
          class="form__col form__col--half"
          prop="cars.0.cap"
          :rules="[{
            validator: validateCap,
            trigger: ['blur']
          }]"
        >
          <ElInput :id="`car-cap-${0}`"
            v-model="propertyForm.cars[0].cap"
            placeholder="Число мест (кроме водителя)"
            @input="(value) => handleNumber(0, 'cap', value)"
          >
            <template #prefix>
              Число мест (кроме водителя)
            </template>
          </ElInput>
        </ElFormItem>
      </div>
      <div
        v-if="propertyForm.typeCar === 'multi'"
      >
        <p v-if="!isMobile"
           class="insurance-chosen-variant__subtitle">
          Укажите авто в таблице или загрузите файл со списком ТС
        </p>

        <div
          class="form__buttons form__buttons--margin-small"
        >
          <ElFormItem
            class="form__col form__col-half-not-line"
            prop="files"
            v-if="!isMobile"
          >
            <ElUpload
              v-model:file-list="propertyForm.files"
              :on-change="handleChangeFiles"
              action="ajax/loadFile.php"
              multiple
              :limit="3"
              :on-success="onUploadFile"
              accept=".xlsx"
            >
              <BaseButton text="Загрузить список"/>
              <template #tip>
                <div class="el-upload__tip">
                  Файл в формате xlsx.
                </div>
              </template>
            </ElUpload>
          </ElFormItem>

          <BaseLink
            text="Скачать шаблон"
            path="https://zettains.ru/upload/Osgop.xlsx"
            tag="a"
            :in-line=true
            v-if="!isMobile"
          />
        </div>

        <ElTable
          :data="propertyForm.cars"
          stripe
          border
          v-if="!isMobile"
          style="width: 100%"
        >
          <el-table-column type="index" width="45"/>
          <el-table-column prop="regNum" label="Рег. номер" width="150">
            <template #default="scope">
              <ElFormItem
                class="form__item"
                :prop="`cars.${scope.$index}.regNum`"
                :rules="[{
            validator: validateRegNum,
            trigger: ['blur']
          }]"
              >
                <ElInput :id="`car-reg-num-${scope.$index}`"
                  v-model="propertyForm.cars[scope.$index].regNum"
                  placeholder="А777АА77"
                  @input="(value) => handleRegNum(scope.$index, value)"
                >
                </ElInput>
              </ElFormItem>
            </template>
          </el-table-column>
          <el-table-column prop="brand" label="Марка">
            <template #default="scope">
              <ElFormItem
                class="form__item"
                :prop="`cars.${scope.$index}.brand`"
                :rules="[{
                      required: true,
                       message: 'Обязательно для заполнения',
                      trigger: ['blur']
                    }]"
              >
                <ElInput :id="`car-brand-${scope.$index}`"
                  v-model="propertyForm.cars[scope.$index].brand"
                  placeholder="Марка"
                  :disabled="propertyForm.cars[scope.$index].brandAutocode"
                >
                </ElInput>
              </ElFormItem>
            </template>
          </el-table-column>
          <el-table-column prop="model" label="Модель">
            <template #default="scope">
              <ElFormItem
                class="form__item"
                :prop="`cars.${scope.$index}.model`"
                :rules="[{
            required: true,
            message: 'Обязательно для заполнения',
            trigger: ['blur']
          }]"
              >
                <ElInput :id="`car-model-${scope.$index}`"
                  v-model="propertyForm.cars[scope.$index].model"
                  placeholder="Модель"
                  :disabled="propertyForm.cars[scope.$index].modelAutocode"
                >
                </ElInput>
              </ElFormItem>
            </template>
          </el-table-column>
          <el-table-column prop="year" label="Год" width="100">
            <template #default="scope">
              <ElFormItem
                class="form__item"
                :prop="`cars.${scope.$index}.year`"
                :rules="[{
            validator: validateYear,
            trigger: ['blur']
          }]"
              >
                <ElInput :id="`car-year-${scope.$index}`"
                  v-model="propertyForm.cars[scope.$index].year"
                  placeholder="Год выпуска"
                  v-mask="'9999'"
                  :disabled="propertyForm.cars[scope.$index].yearAutocode"
                >
                </ElInput>
              </ElFormItem>
            </template>
          </el-table-column>
          <el-table-column prop="cap" label="Число мест" width="110">
            <template #default="scope">
              <ElFormItem
                class="form__item"
                :prop="`cars.${scope.$index}.cap`"
                :rules="[{
            validator: validateCap,
            trigger: ['blur']
          }]"
              >
                <ElInput :id="`car-cap-${scope.$index}`"
                  v-model="propertyForm.cars[scope.$index].cap"
                  placeholder="Число мест (кроме водителя)"
                  @input="(value) => handleNumber(scope.$index, 'cap', value)"
                >
                </ElInput>
              </ElFormItem>
            </template>
          </el-table-column>
          <el-table-column width="50" class-name="delete-button">
            <template #default="scope">
              <el-button
                type="danger"
                size="small"
                circle
                icon="el-icon-delete"
                @click.prevent="deleteRow(scope.$index)"
              />
            </template>
          </el-table-column>
        </ElTable>
        <div class="mobile-cars-container" v-if="isMobile" v-for="(car, ind) in propertyForm.cars">
          <div class="header-container-card">
            <p>Транспортное средство&nbsp;{{ `${ind + 1}` }}</p>
            <el-button
              type="danger"
              size="small"
              circle
              class="btn-mob-delete"
              icon="el-icon-delete"
              @click.prevent="deleteRow(ind)"
            />
          </div>
          <ElFormItem
            class="form__item"
            :prop="`cars.${ind}.regNum`"
            :rules="[{
            validator: validateRegNum,
            trigger: ['blur']
          }]"
          >
            <ElInput :id="`car-reg-num-${ind}`"
              v-model="propertyForm.cars[ind].regNum"
              placeholder="А777АА77"
              @input="(value) => handleRegNum(ind, value)"
            >

              <template #prefix>
                Регистрационный номер
              </template>
            </ElInput>
          </ElFormItem>
          <ElFormItem
            class="form__item"
            :prop="`cars.${ind}.brand`"
            :rules="[{
            required: true,
             message: 'Обязательно для заполнения',
            trigger: ['blur']
          }]"
          >
            <ElInput :id="`car-brand-${ind}`"
              v-model="propertyForm.cars[ind].brand"
              placeholder="Марка"
              :disabled="propertyForm.cars[ind].brandAutocode"
            >
              <template #prefix>
                Марка
              </template>
            </ElInput>
          </ElFormItem>

          <ElFormItem
            class="form__item"
            :prop="`cars.${ind}.model`"
            :rules="[{
            required: true,
            message: 'Обязательно для заполнения',
            trigger: ['blur']
          }]"
          >
            <ElInput :id="`car-model-${ind}`"
              v-model="propertyForm.cars[ind].model"
              placeholder="Модель"
              :disabled="propertyForm.cars[ind].modelAutocode"
            >
              <template #prefix>
                Модель
              </template>
            </ElInput>
          </ElFormItem>
          <div
            class="form__item form__item--col"
          >
            <ElFormItem
              class="form__col form__col--half"
              :prop="`cars.${ind}.year`"
              :rules="[{
            validator: validateYear,
            trigger: ['blur']
          }]"
            >
              <ElInput :id="`car-year-${ind}`"
                v-model="propertyForm.cars[ind].year"
                placeholder="Год выпуска"
                v-mask="'9999'"
                :disabled="propertyForm.cars[ind].yearAutocode"
              >
                <template #prefix>
                  Год выпуска
                </template>
              </ElInput>
            </ElFormItem>

            <ElFormItem
              class="form__col form__col--half"
              :prop="`cars.${ind}.cap`"
              :rules="[{
            validator: validateCap,
            trigger: ['blur']
          }]"
            >
              <ElInput :id="`car-cap-${ind}`"
                v-model="propertyForm.cars[ind].cap"
                placeholder="Число мест (кроме водителя)"
                @input="(value) => handleNumber(ind, 'cap', value)"
              >
                <template #prefix>
                  Число мест (кроме водителя)
                </template>
              </ElInput>
            </ElFormItem>
          </div>
        </div>
        <el-button
          :disabled="isDisabledAdd"
          class="mt-4 add-button"
          style="width: 100%"
          @click="onAddItem"
        >
          Добавить ТС
        </el-button>
      </div>

      <div v-if="isShortTerm" class="form__item form__item--col policy-dates--short-term">
        <ElFormItem
          class="form__col form__col--half"
          prop="policyDates.police_date"
          :rules="[{ validator: validatePolicyStartDate, trigger: ['blur', 'change'] }]"
        >
          <ElDatePicker
            v-input-id="'property-policy-start-date'"
            v-model="propertyForm.policyDates.police_date"
            type="date"
            placeholder="дд.мм.гггг"
            format="dd.MM.yyyy"
            value-format="dd.MM.yyyy"
            :disabled="!!lockedStartDate"
            :picker-options="{ disabledDate: disablePolicyStartDate }"
          />
          <span class="form__label">Дата начала полиса</span>
        </ElFormItem>
        <ElFormItem
          class="form__col form__col--half"
          prop="policyDates.end_police_date"
          :rules="[{ validator: validatePolicyEndDate, trigger: ['blur', 'change'] }]"
        >
          <ElDatePicker
            v-input-id="'property-policy-end-date'"
            v-model="propertyForm.policyDates.end_police_date"
            type="date"
            placeholder="дд.мм.гггг"
            format="dd.MM.yyyy"
            value-format="dd.MM.yyyy"
            :disabled="!parsePolicyDate(propertyForm.policyDates.police_date)"
            :picker-options="{ disabledDate: disablePolicyEndDate }"
          />
          <span class="form__label">Дата окончания полиса</span>
        </ElFormItem>
      </div>

      <div class="form__buttons form__buttons--margin-small">
        <BaseButton text="Назад"
                    theme="muted"
                    size="large"
                    is-text
                    @click.native="$emit('prev-step')"
        />
        <BaseButton
          v-if="!isDefineAuto"
          text="Продолжить"
          size="large"
          :is-disabled="checkRegNumIsDisabled"
          @click.native="checkRegNum"
        />
        <BaseButton
          v-else
          text="Рассчитать стоимость"
          size="large"
          :is-disabled="submitIsDisabled"
          @click.native="onSubmit($refs.propertyFormRef)"
        />

      </div>
    </ElForm>
    <ModalPolicyIssuanceGrz
      :visible="showErrorModalGrz"
      :grz-message-list="grzMessageList"
      modal-width="719px"
      @close="handleCloseModalGrz"
    />
  </div>
</template>

<script>
import {addDays, startOfDay, parse, isValid, format, differenceInCalendarDays} from 'date-fns';
import BaseButton from '@/components/ui/BaseButton';
import {Notification} from 'element-ui';
import BaseLink from "@/components/ui/BaseLink.vue";
import {getAutoInfo} from "@/api/routes/auto";
import Cookies from 'js-cookie';
import {MAX_CHECK_AUTOCODE, MAX_AUTO} from "@/consts";
import {getKuv} from "../../api/routes/inn";
import {searchGrzByInn} from '@/api/routes/agreement';
import ModalPolicyIssuanceGrz from '@/components/modals/ModalPolicyIssuanceGrz';

export default {
  name: 'FormClientDetails',
  components: {
    BaseLink,
    BaseButton,
    ModalPolicyIssuanceGrz,
  },
  inject: ['setShowGlobalSpinner'],
  props: {
    policyDates: {type: Object, required: true},
    lockedStartDate: String,
    isShortTerm: Boolean,
    tariff: Array,
    uniqCode: String,
    prolongationData: Object,
    inn: String,
  },
  data() {
    return {
      propertyForm: {
        typeCar: 'single',
        policyDates: this.policyDates,
        cars: [
          {
            'brand': '',
            'brandAutocode': false,
            'model': '',
            'modelAutocode': false,
            'regNum': '',
            'year': '',
            'yearAutocode': false,
            'cap': '',
            'isCheckAutocode': false,
            'category': '',
          }
        ],
        files: [],
        allSum: 0,
        kuv: 0.5,
        newTariffs: [],
        newProlongAgreement: {},
      },
      rules: {},
      isMobile: false,
      showErrorModal: false,
      showErrorModalGrz: false,
      grzMessageList: [],
      existRegNum: [],
    }
  },
  computed: {
    isDefineAuto() {
      if (this.propertyForm.typeCar === 'single') {
        return this.propertyForm.cars[0].isCheckAutocode;
      }

      let isDefinedAll = true;

      this.propertyForm.cars.forEach((car) => {
        if (!car.isCheckAutocode) {
          isDefinedAll = false;
        }
      })

      return isDefinedAll;
    },
    isShowFieldsSingle() {
      if (this.propertyForm.typeCar !== 'single') {
        return false;
      }

      return this.isDefineAuto;
    },
    isDisabledAdd() {
      if (!this.isMobile) {
        return false;
      }

      if (this.propertyForm.cars.length >= 3) {
        return true;
      }

      return false;
    },
    checkRegNumIsDisabled() {
      if (this.propertyForm.typeCar === 'single') {
        if (!this.propertyForm?.cars[0]?.regNum) {
          return true;
        }
      }

      return false;
    },
    submitIsDisabled() {
      if (this.propertyForm.cars.length <= 0) {
        return true;
      }

      if (this.propertyForm.typeCar === 'single') {
        if (!this.propertyForm?.cars[0]?.brand) {
          return true;
        }

        if (!this.propertyForm?.cars[0]?.model) {
          return true;
        }

        if (!this.propertyForm?.cars[0]?.regNum) {
          return true;
        }

        if (!this.propertyForm?.cars[0]?.year) {
          return true;
        }

        if (!this.propertyForm?.cars[0]['cap']) {
          return true;
        }
      }

      return false;
    },
  },
  watch: {
    lockedStartDate: {
      immediate: true,
      handler(value) {
        if (value) {
          this.propertyForm.policyDates.police_date = value;
        }
      },
    },
    'propertyForm.policyDates.police_date'() {
      if (this.isShortTerm && this.propertyForm.policyDates.end_police_date) {
        this.$nextTick(() => this.$refs.propertyFormRef.validateField('policyDates.end_police_date'));
      }
    },
    'propertyForm.cars': {
      handler(newValue) {
        const count = newValue?.length ?? 0;
        this.$emit('count-cars', count);
      },
      deep: true,
    },
    prolongationData(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        if (newValue?.cars?.length) {
          this.updateAllCars(newValue?.cars ?? []);
          this.$emit('count-cars', newValue?.cars?.length);
        }
      }
    },
  },
  methods: {
    getSubmitData() {
      const {policyDates, ...form} = this.propertyForm;
      return {...form, ...policyDates};
    },
    parsePolicyDate(value) {
      if (typeof value !== 'string' || !/^\d{2}\.\d{2}\.\d{4}$/.test(value)) {
        return null;
      }
      const date = parse(value, 'dd.MM.yyyy', new Date());
      return isValid(date) && format(date, 'dd.MM.yyyy') === value ? date : null;
    },
    disablePolicyStartDate(date) {
      return startOfDay(date) < addDays(startOfDay(new Date()), 1);
    },
    disablePolicyEndDate(date) {
      const start = this.parsePolicyDate(this.propertyForm.policyDates.police_date);
      return !start || differenceInCalendarDays(date, start) < 0 || differenceInCalendarDays(date, start) > 364;
    },
    validatePolicyStartDate(rule, value, callback) {
      if (this.lockedStartDate) {
        return callback(value === this.lockedStartDate ? undefined : new Error('Дата начала должна быть следующим днём после окончания продлеваемого договора'));
      }
      const date = this.parsePolicyDate(value);
      if (!date) {
        return callback(new Error('Введите корректную дату начала полиса'));
      }
      if (this.disablePolicyStartDate(date)) {
        return callback(new Error('Дата начала полиса должна быть не раньше завтрашнего дня'));
      }
      callback();
    },
    validatePolicyEndDate(rule, value, callback) {
      const date = this.parsePolicyDate(value);
      if (!date) {
        return callback(new Error('Введите корректную дату окончания полиса'));
      }
      if (this.disablePolicyEndDate(date)) {
        return callback(new Error('Дата окончания должна быть не раньше даты начала, срок полиса — не более 365 дней включительно'));
      }
      callback();
    },
    handleCloseModalGrz() {
      this.showErrorModalGrz = false

      if (
        this.propertyForm.cars.length === 1
        && !!this.propertyForm.newProlongAgreement?.id
      ) {
        this.$emit('form-submit', this.getSubmitData())
      }
    },
    updateAllCars(cars) {
      if (cars?.length >= 1) {
        let newCars = [];
        this.$set(this.propertyForm, 'typeCar', 'multi');
        Cookies.set('osgop_last_count_check', '0', {expires: 1});
        cars.forEach((car) => {
          newCars.push({
            'brand': car?.mark ?? '',
            'brandAutocode': false,
            'model': car?.model ?? '',
            'modelAutocode': false,
            'regNum': car?.regNumber ?? '',
            'year': car?.releaseYear ?? '',
            'yearAutocode': false,
            'cap': car?.countPassenger ?? '',
            'isCheckAutocode': false,
            'category': '',
          });
        })

        this.propertyForm.cars = newCars;
        this.$emit('count-cars', newCars.length);
        this.$emit('change-type', 'multi')
      }
    },
    checkRegNum() {
      if (!this.isDefineAuto) {
        this.$refs.propertyFormRef.validate(valid => {
          if (valid) {
            this.getDataAutocode();
          }
        });
      }
    },
    async getDataAutocode() {
      const _this = this;
      let lastCount = Number(Cookies.get('osgop_last_count_check'));
      if (!lastCount || isNaN(lastCount)) {
        lastCount = 0;
      }
      if (lastCount >= MAX_CHECK_AUTOCODE) {
        this.$emit(
          'show-request-form'
        );
        return;
      }

      this.setShowGlobalSpinner(true);

      let autoData = {};

      if (this.propertyForm.typeCar === 'single') {
        autoData = await getAutoInfo([this.propertyForm.cars[0].regNum], this.uniqCode);
        lastCount += 1;
        Cookies.set('osgop_last_count_check', lastCount.toString(), {expires: 1});
      } else {
        let regNums = [];
        this.propertyForm.cars.forEach((car) => {
          if (!car.isCheckAutocode) {
            regNums.push(car.regNum);
          }
        })

        if (regNums.length > 0) {
          autoData = await getAutoInfo(regNums, this.uniqCode);
          lastCount += regNums.length;
          Cookies.set('osgop_last_count_check', lastCount.toString(), {expires: 1});
        }
      }

      if (autoData?.result && autoData.result === true) {
        this.propertyForm.cars.forEach((car, index) => {
          autoData.cars.forEach((carReg, indexReg) => {
            if (car.regNum === carReg.regNum) {
              if (carReg.mark) {
                _this.$set(_this.propertyForm.cars[index], 'brand', carReg.mark);
                _this.$set(_this.propertyForm.cars[index], 'brandAutocode', !!carReg.mark);
              }

              if (carReg.model) {
                _this.$set(_this.propertyForm.cars[index], 'model', carReg.model);
                _this.$set(_this.propertyForm.cars[index], 'modelAutocode', !!carReg.model);
              }

              if (carReg.year) {
                _this.$set(_this.propertyForm.cars[index], 'year', carReg.year);
                _this.$set(_this.propertyForm.cars[index], 'yearAutocode', !!carReg.year);
              }

              if (carReg.year) {
                _this.$set(_this.propertyForm.cars[index], 'year', carReg.year);
                _this.$set(_this.propertyForm.cars[index], 'yearAutocode', !!carReg.year);
              }

              _this.$set(_this.propertyForm.cars[index], 'category', !!carReg.category);
              _this.$set(_this.propertyForm.cars[index], 'isCheckAutocode', true);
            }
          })
        })
      }

      this.setShowGlobalSpinner(false);
    },
    handleChangeFiles(file, fileList) {
      this.propertyForm.files = fileList;
    },
    clearEmptyCars() {
      this.propertyForm.cars = this.propertyForm.cars.filter((car) => {
        if (
          !car.brand
          && !car.model
          && !car.regNum
          && !car.year
          && (!car.cap || car.cap == 0)
        ) {
          return false;
        }

        return true;
      });

      if (this.propertyForm.typeCar.length <= 0) {
        this.propertyForm.cars.push({
          'brand': '',
          'brandAutocode': false,
          'model': '',
          'modelAutocode': false,
          'regNum': '',
          'year': '',
          'yearAutocode': false,
          'cap': '',
          'isCheckAutocode': false,
          'category': '',
        });
      }

    },
    onAddItem() {
      if (this.propertyForm.cars.length >= MAX_AUTO) {
        this.errorMessage('Ошибка', 'Максимальное кол-во ТС не должно превышать ' + MAX_AUTO);
        return;
      }

      this.propertyForm.cars.push({
        'brand': '',
        'brandAutocode': false,
        'model': '',
        'modelAutocode': false,
        'regNum': '',
        'year': '',
        'yearAutocode': false,
        'cap': '',
        'isCheckAutocode': false,
        'category': '',
      });
    },
    deleteRow(index) {
      this.propertyForm.cars.splice(index, 1);

      if (this.propertyForm.cars.length <= 0) {
        this.propertyForm.cars.push({
          'brand': '',
          'brandAutocode': false,
          'model': '',
          'modelAutocode': false,
          'regNum': '',
          'year': '',
          'yearAutocode': false,
          'cap': '',
          'isCheckAutocode': false,
          'category': '',
        });
      }
    },
    errorMessage(title, text) {
      Notification({
        title: title,
        message: text,
        type: 'error',
      })
    },
    successMessage(title, text) {
      Notification({
        title: title,
        message: text,
        type: 'success',
      })
    },
    onUploadFile(response, uploadFile, uploadFiles) {
      if (this.propertyForm.cars && this.propertyForm.cars.length > MAX_AUTO) {
        this.errorMessage('Ошибка загрузки', 'Максимальное кол-во ТС не должно превышать ' + MAX_AUTO);
        return;
      }

      if (!response?.result) {
        this.errorMessage('Ошибка загрузки', 'Неизвестная ошибка');
        return;
      }

      if (response?.result === 'error') {
        this.errorMessage('Ошибка загрузки', response?.errorText ?? 'Неизвестная ошибка');
        return;
      }

      if (response?.result === 'ok') {
        this.successMessage('Успешная загрузка', 'Успешно импортирован список ТС');

        let isMaxAuto = false;

        const _this = this;

        if (response.cars.length > 0) {
          this.propertyForm.cars = this.propertyForm.cars.filter(car => !Object.values(car).every(value => !value));
        }

        response.cars.forEach((value, index) => {
          if (_this.propertyForm.cars && _this.propertyForm.cars.length >= MAX_AUTO) {
            isMaxAuto = true;
            return;
          }

          _this.propertyForm.cars.push({
            brand: value.brand,
            model: value.model,
            regNum: value.number,
            year: value.year,
            cap: value.cap,
          });
        });

        if (isMaxAuto) {
          this.errorMessage('Ошибка загрузки', 'Максимальное кол-во ТС не должно превышать ' + MAX_AUTO);
        }

        return;
      }

      this.clearEmptyCars();
      this.propertyForm.files = uploadFiles;
    },
    handleNumber(index, param, value) {
      this.propertyForm.cars[index][param] = value.replace(/[^0-9]/g, '');
    },
    handleRegNum(index, value) {
      this.isDefineAuto = false;
      this.propertyForm.cars[index]['regNum'] = value.toUpperCase();
      this.propertyForm.cars[index]['isCheckAutocode'] = false;
    },
    validateRegNum(rule, value, callback) {
      const regexCar = /^[АВЕКМНОРСТУХавекмнорстух]{1}[0-9]{3}[АВЕКМНОРСТУХавекмнорстух]{2}[0-9]{2,3}$/;
      const regexTaxi = /^[АВЕКМНОРСТУХавекмнорстух]{2}[0-9]{3,4}[0-9]{2,3}$/;

      if (this.existRegNum.includes(value)) {
        callback(new Error('ГРЗ застрахован'));
      } else if (regexCar.test(value) || regexTaxi.test(value)) {
        callback();
      } else {
        callback(new Error('Некорректный формат номера'))
      }
    },
    validateCap(rule, value, callback) {
      if (Number(value) > 0) {
        callback();
      } else {
        callback(new Error('Некорректное значение'))
      }
    },
    validateYear(rule, value, callback) {
      const regex = /^\d{4}$/;
      let currentYear = new Date().getFullYear();

      if (regex.test(value) && Number(value) <= currentYear && Number(value) >= currentYear - 25) {
        callback();
      } else {
        callback(new Error('Некорректный год выпуска автомобиля'))
      }
    },
    onSubmit(formRef) {
      formRef.validate(async (valid) => {
        if (valid) {
          this.setShowGlobalSpinner(true);
          try {
            const resultKuv = await getKuv(this.inn, {
              isShortTerm: this.isShortTerm,
              startDate: this.propertyForm.policyDates.police_date,
              endDate: this.propertyForm.policyDates.end_police_date,
            });
            this.propertyForm.kuv = resultKuv.kuv;
            this.propertyForm.newTariffs = resultKuv.tariffList;
            const allPremium = resultKuv.tariffList.reduce((sum, tariff) => sum + Number(tariff.premium), 0);
            this.propertyForm.allSum = Math.round(allPremium * (this.propertyForm.typeCar === 'single' ? 1 : this.propertyForm.cars.length) * 100) / 100;
            this.existRegNum = [];
            this.grzMessageList = [];

            // Запрос на проверку ГРЗ перед оформлением
            const grzList = await searchGrzByInn(this.inn, this.propertyForm.cars, this.prolongationData?.id ?? '');
            this.propertyForm.newProlongAgreement = {};

            if (
              grzList?.result
              && grzList?.grzList
              && grzList?.grzList?.length
            ) {
              if (
                this.propertyForm.cars.length === 1
                && grzList?.availableProlong
              ) {
                this.propertyForm.newProlongAgreement = grzList?.agreement;
                this.propertyForm.cars.forEach((car, index) => {
                  grzList.grzList.forEach((existCar, existIndex) => {
                    if (car?.regNum === existCar?.regNumber) {
                      this.grzMessageList.push(('ГРЗ ' + existCar?.regNumber + ' уже застрахован в договоре ' + existCar?.agreementNumber));

                      if (grzList?.agreement?.id !== existCar?.agreementNumber) {
                        this.existRegNum.push(existCar?.regNumber);
                      }
                    }
                  })
                })
              } else {
                this.propertyForm.cars.forEach((car, index) => {
                  grzList.grzList.forEach((existCar, existIndex) => {
                    if (car?.regNum === existCar?.regNumber) {
                      this.grzMessageList.push(('ГРЗ ' + existCar?.regNumber + ' уже застрахован в договоре ' + existCar?.agreementNumber));
                      this.existRegNum.push(existCar?.regNumber);
                    }
                  })
                })
              }
              if (this.grzMessageList.length) {
                this.setShowGlobalSpinner(false);
                this.showErrorModalGrz = true;
                this.$nextTick(() => {
                  formRef.validate();
                });

                return;
              }
            }

            this.$emit('form-submit', this.getSubmitData())
          } catch (error) {
            this.errorMessage('Ошибка расчёта', error.message || 'Не удалось получить тарифы');
          } finally {
            this.setShowGlobalSpinner(false);
          }
        }
      })
    },
  },
  async mounted() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent) ||
      /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream ||
      /windows phone/i.test(userAgent)) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }

    if (this.isMobile) {
      this.propertyForm.typeCar = 'multi';
      this.$emit('change-type', 'multi');
    }
  }
}
</script>

<style scoped lang=scss>
.policy-dates--short-term {
  @media #{$screen-small} {
    margin-bottom: rem(24px);
  }
}

.form-property-details {

  &__form {
    display: flex;
    flex-direction: column;
  }

  &__comment {
    @include text-normal($font-weight-regular, $line-height-normal);

    margin-top: rem($gap-big);

    @media #{$screen-medium} {
      font-size: rem($font-size-small);

      margin-top: rem($gap-medium);
    }

    @media #{$screen-small} {
      font-size: rem($font-size-mini);
    }
  }

  &__terms-agree {
    margin-top: rem($gap-normal);

    display: flex;

    &-text {
      @include text-normal($font-weight-regular, $line-height-normal);

      margin-left: rem($gap-mini);

      @media #{$screen-medium} {
        font-size: rem($font-size-small);
      }

      @media #{$screen-small} {
        font-size: rem($font-size-mini);
      }

      &--link {
        text-decoration: underline;

        color: inherit;
      }
    }
  }

  &__button-send-link {
    margin-top: rem($gap-mini);

    align-self: flex-end;
  }
}

.el-radio-group {
  @include text-medium($font-weight-regular, $line-height-medium);
  font-family: $font-family-secondary;
  margin-top: rem($gap-normal);
  margin-bottom: rem($gap-medium);
}

.insurance-chosen-variant {
  &__subtitle {
    @include text-medium($font-weight-regular, $line-height-medium);

    font-family: $font-family-secondary;

    margin-top: rem($gap-normal);
    margin-bottom: rem($gap-medium);
    width: fit-content;

    color: $color-text-muted-low2;

    @media #{$screen-big} {
      font-size: rem($font-size-normal);
    }
  }
}

.el-button--small.is-circle {
  padding: 7px !important;
}

.add-button {
  &:hover {
    color: $primary;
    border-color: $primary;
    background-color: transparent;
  }

  &:focus {
    color: $primary;
    border-color: $primary;
    background-color: transparent;
  }

  @media #{$screen-small} {
    margin-bottom: 1rem;
  }
}

.form__col--half-not-inline {
  width: calc(50% - .75rem) !important;
  @media #{$screen-small} {
    width: calc(50% - .75rem) !important;
  }
}

.mobile-cars-container {
  background-color: hsla(0, 0%, 93%, .5);
  padding: 1rem;
  border: none;
  border-radius: 1rem;
  margin-bottom: 1rem;
}

.form__buttons {
  @media #{$screen-small} {
    margin-top: 0;
  }
}

.header-container-card {
  display: flex;
  justify-content: space-between;
}

.add-button.el-button.is-disabled {
  color: #c0c4cc !important;
  cursor: not-allowed !important;
  background-image: none !important;
  background-color: #fff !important;
  border-color: #ebeef5 !important;
}

.delete-button {
  max-height: 28px;
}

.btn-mob-delete {
  max-height: 28px;
  max-width: 28px;
}


</style>
